import React from 'react'

import './styles.scss'

export interface spinnerProps {
  size?: 'default' | 'small'
}

const Spinner: React.FC<spinnerProps> = ({ size = 'default' }) => {
  return (
    <div
      data-testid="spinner"
      className={size === 'small' ? 'Spinner--small' : 'Spinner'}
    ></div>
  )
}

export default Spinner
